import React from 'react';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';
import { deriveClearedCount } from '../transactions/v2/OverviewClosingPath';

// Hero status row (dark-green banner, D-39): milestone progress bar. The closing
// countdown lives in the at-a-glance tiles (PortalGlanceStrip) instead.
// Renders nothing when there are no applicable milestones.
function PortalStatusBar({ transaction, completedMilestones }) {
    const { t } = usePortalLanguage();
    const { x, n } = deriveClearedCount(transaction || {}, completedMilestones || {});
    const pct = n > 0 ? Math.round((x / n) * 100) : 0;
    if (n === 0) return null;

    return (
        <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
            <div className="w-full sm:max-w-xs">
                <div className="mb-1 flex items-center justify-between text-xs font-medium text-[color:var(--header-text-color)]">
                    <span>{t('Progress')}</span>
                    <span>{t('{x} of {n} steps complete', { x, n })}</span>
                </div>
                <div className="h-2 w-full overflow-hidden rounded-full bg-[color:var(--sidebar-item-hover)]">
                    <div
                        className="h-full rounded-full bg-[color:var(--color-accent)] transition-all duration-700 ease-out"
                        style={{ width: `${pct}%` }}
                        role="progressbar"
                        aria-valuenow={pct}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    />
                </div>
            </div>
        </div>
    );
}

export default PortalStatusBar;
